import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    maxWidth: '600px',
  },

  titleWrapper: {
    display: 'flex',
  },

  titleProfiles: {
    color: '#102131',
    fontSize: '20px',
    fontWeight: '600',
  },

  buttonFooter: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  button: {
    width: '45%',
    '@media(max-width: 900px)': {
      width: '100%',
    },
  },

  titleCampaignDownload: {
    color: '#102131',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '32px',
    marginTop : '40px'
  },

  alert: {
    marginBottom: 30
  }
});
